import { CalendarCheck, ZoomIn } from 'lucide-react';
import { useLang } from '../../i18n/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { BookNowButton } from './BookNowButton';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '../ui/dialog';
import { priceList, priceListImage as img } from '../../mock';

const ALT = 'The Real Turkish Barber Bray price list';

const PriceText = () => (
  <div className="sr-only" data-testid="price-list-text">
    {priceList.map((g) => (
      <div key={g.category}>
        <h3>{g.category}</h3>
        <ul>{g.items.map(([name, price]) => <li key={name}>{name}: {price}</li>)}</ul>
      </div>
    ))}
  </div>
);

export const Prices = () => {
  const { t } = useLang();
  return (
    <section id="prices" className="py-14 lg:py-20 bg-surface border-y border-white/5">
      <div className="max-w-3xl mx-auto px-4 lg:px-8">
        <SectionHeading label={t.pricesSection.label} title={t.pricesSection.title} />
        <Dialog>
          <DialogTrigger asChild>
            <button type="button" data-testid="price-list-image-button" aria-label={t.pricesSection.zoom} className="group block w-full cursor-zoom-in focus:outline-none focus-visible:ring-2 focus-visible:ring-gold">
              <picture>
                <source srcSet={img.webp} type="image/webp" />
                <img src={img.jpg} alt={ALT} width={img.width} height={img.height} loading="lazy" decoding="async" data-testid="price-list-image" className="w-full h-auto shadow-[0_20px_60px_rgba(0,0,0,0.6)]" />
              </picture>
              <span className="mt-3 flex items-center justify-center gap-1.5 text-gold/80 text-xs uppercase tracking-widest group-hover:text-gold transition-colors">
                <ZoomIn size={14} /> {t.pricesSection.zoom}
              </span>
            </button>
          </DialogTrigger>
          <DialogContent data-testid="price-list-zoom-dialog" className="max-w-[min(96vw,1100px)] p-0 gap-0 overflow-hidden bg-ink border-gold/30 [&>button]:z-10 [&>button]:p-2 [&>button]:opacity-100 [&>button]:!bg-ink/90 [&>button]:!text-gold [&>button>svg]:h-5 [&>button>svg]:w-5">
            <DialogTitle className="sr-only">{t.pricesSection.title}</DialogTitle>
            <div className="max-h-[94vh] overflow-auto" data-testid="price-list-zoom-scroll">
              <img src={img.full} alt={ALT} className="w-[220vw] max-w-none md:w-full h-auto" data-testid="price-list-zoom-image" />
            </div>
          </DialogContent>
        </Dialog>
        <PriceText />
        <div className="text-center mt-12">
          <BookNowButton
            testId="prices-book-now-button"
            className="inline-flex items-center gap-2 bg-gold hover:bg-gold-dark text-ink font-bold uppercase tracking-widest px-8 py-4 transition-colors text-sm"
          >
            <CalendarCheck size={18} /> {t.pricesSection.book}
          </BookNowButton>
        </div>
      </div>
    </section>
  );
};
